import { isNewCampaignForAgent } from ".";
import { useSelector } from "react-redux";

import { SETTINGS_NEW_FEATURE_CAMPAIGNS, SETTINGS_SECTION_KEYS } from "constants/settings/sections";
import { selectLoggedInAgent } from "store/entities/agents";

export default function useNewFeaturesCount(): number {
  const agent = useSelector(selectLoggedInAgent);

  return Object.keys(SETTINGS_SECTION_KEYS).reduce((count, section) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const [flagName] = SETTINGS_SECTION_KEYS[section];
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const lastVisitedDate = agent.flags[flagName] || agent.createdAt;
    const newCampaignFound =
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (SETTINGS_NEW_FEATURE_CAMPAIGNS[section] || []).find((campaign: any) =>
        isNewCampaignForAgent(agent.createdAt, lastVisitedDate, campaign)
      ) !== undefined;

    if (newCampaignFound) {
      return count + 1;
    }

    return count;
  }, 0);
}
